import React from 'react';

const HourlyReport = () => {
	return (
		<div>
			<h1>Hourly Report Under Construction</h1>
		</div>
	);
};

export default HourlyReport;
